import { Controller, useForm } from 'react-hook-form';
import { MdChevronLeft } from 'react-icons/md';
import { Button, Divider, IconButton, ModalBody, ModalFooter, ModalHeader, TmdxTextarea } from '@ds';
import { useCaseNotesStore } from '@/store/case-notes.store';
import { useCreateCaseNoteMutation } from '@/queries/case';
import { NOTE_MAX_LENGTH } from './constants';

export const AddNoteModalContent = ({ caseId }: { caseId: string }) => {
  const { isPending, mutateAsync: submitCaseNote } = useCreateCaseNoteMutation();
  const setCreateNote = useCaseNotesStore.use.setCreateNote();
  const { control, handleSubmit, getValues, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      message: '',
    },
  });

  const closeAddNote = () => setCreateNote(false);

  const onSaveSubmit = async () => {
    await submitCaseNote({ caseId, message: getValues('message') });
    closeAddNote();
  };

  return (
    <>
      <ModalHeader>
        <IconButton size="xs" variant="outline" startContent={<MdChevronLeft />} onPress={closeAddNote} />
        <h3 className="ml-3">Add New Note</h3>
      </ModalHeader>
      <div className="px-6">
        <Divider />
      </div>
      <ModalBody className="flex-none py-6">
        <form id="add-note-form" onSubmit={handleSubmit(onSaveSubmit)}>
          <Controller
            name="message"
            control={control}
            rules={{ required: true, maxLength: NOTE_MAX_LENGTH }}
            render={({ field, fieldState: { invalid, error } }) => (
              <TmdxTextarea
                fullWidth
                disableAnimation
                minRows={6}
                maxLength={NOTE_MAX_LENGTH}
                placeholder="Type here"
                isInvalid={invalid}
                errorMessage={error?.message}
                {...field}
              />
            )}
          />
        </form>
      </ModalBody>
      <div className="px-6">
        <Divider />
      </div>
      <ModalFooter>
        <div className="flex gap-3">
          <Button variant="outline" onPress={closeAddNote} className="flex-1">
            Discard
          </Button>
          <Button
            type="submit"
            form="add-note-form"
            variant="solid"
            isLoading={isPending}
            isDisabled={!formState.isValid}
            className="flex-1 text-base-90"
          >
            Add Note
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
